import { classes } from "@tm/utils"
import { forwardRef } from "react"
import { Box, BoxProps, styled } from "@mui/material"
import { offerItemClasses, offerItemName, offerItemSlots } from "@tm/themes"

const OfferItemErpAvailabilitiesComponent = forwardRef<HTMLDivElement, BoxProps>((props, ref) => (
    <Box {...props} className={classes(offerItemClasses.erpAvailabilities, props.className)} ref={ref} />
))
export const OfferItemErpAvailabilities = styled(OfferItemErpAvailabilitiesComponent, {
    name: offerItemName,
    slot: offerItemSlots.erpAvailabilities,
    overridesResolver: (_, styles) => styles.erpAvailabilities,
})({
    ".erp-info-availability": {
        display: "flex",
        flexDirection: "row",
    },
    ".erp-info__availability__wrapper .image": {
        maxWidth: 110,
    },
    ".ExtendedDelivery": {
        button: {
            padding: 4,
        },
        ".btn__icon": {
            margin: 0,
        },
        ".btn__content": {
            display: "none",
        },
    },
})
